// Holds the discount event/variant the server resolved for this visitor, captured
// from the /discount-config and /homepage-promo responses. Cart-creation calls
// echo it back so the cart (and its eventual purchase) is attributed to the
// discount it was priced under. Persisted to localStorage so it survives reloads.

const KEY = "activePromoEvent";

let current = (() => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
})();

// event = { id, variant } | null
export const setActivePromoEvent = (event) => {
  current = event && event.id ? { id: event.id, variant: event.variant || "A" } : null;
  try {
    if (current) localStorage.setItem(KEY, JSON.stringify(current));
    else localStorage.removeItem(KEY);
  } catch (e) {
    // ignore storage errors
  }
};

export const getActivePromoEvent = () => current;

// Shape stored on the cart document (server reads `discountEvent`).
export const getCartDiscountEvent = () =>
  current ? { eventId: current.id, variant: current.variant } : null;
